<div class="customize-fields__inner-container">
  <field-type-list-simple
    [field]="customizeFieldMoney.moneyTypeInfo"
    [preSelectItem]="customizeFieldMoney.field.currencyId"
    [listValues]="customizeFieldMoney.moneyTypeList"
    (itemSelected)="itemSelected($event, 'currencyId')">
  </field-type-list-simple>
  <field-type-number [field]="customizeFieldMoney.defaultValueInfo"
      [preSelectItem]="customizeFieldMoney.field.defaultValue"
      [decimals]="customizeFieldMoney.field.decimals"
      (itemSelected)="itemSelected($event, 'defaultValue')">
  </field-type-number>
  <customize-fields-switch-form
    [field]="customizeFieldMoney.field"
    [small]="true"
    [concept]="concept"
    [isPrivate]="isPrivate"
    [hiddenInLandings]="hiddenInLandings"
    [previewMode]="previewMode"></customize-fields-switch-form>
</div>
